import { Grid, Card, CardHeader, CardContent, Typography } from '@mui/material';
import { stateApiKeyStore } from '../../../api/states-api-key-store';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { FormFormattedInput } from '../../../components/hook-form/form-formatted-input.component';
import { PHONENUMBER_FORMAT, ZIPCODE_FORMAT } from '../../../constants';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '20px' },
  headingStyle: { fontWeight: 'bold' },
};

export interface Option {
  value: any;
  label: string;
  isDefault: boolean;
}

export const OfficeContactInfoForm = () => {
  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary" style={styling.headingStyle}>
            ADDRESS
          </Typography>
        }
      ></CardHeader>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormInput name="contactStreet" label="Street Address" />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormInput name="contactCity" label="City" />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormSelectDynamic
              name="contactState"
              label="State"
              getQueryKeyConfig={() => stateApiKeyStore.getStates()}
              optionsValueKey="stateID"
              optionsLabelKeys={['stateName']}
            />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormFormattedInput name="contactZip" label="Zip Code" format={ZIPCODE_FORMAT} />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormFormattedInput name="contactPhone" label="Contact Phone" format={PHONENUMBER_FORMAT} />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormInput name="contactEmail" label="Contact Email" />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
